import { atom } from "recoil";
import { MENU_IDS, MenuId } from "oc/configs/menu-constants";
import { ocPersistAtom } from "oc/states/persist-atom";

export const ocActiveMenuState = atom<MenuId>({
  key: "ocActiveMenuState",
  default: MENU_IDS.MAIN,
  effects_UNSTABLE: [ocPersistAtom],
});
